import React, { Fragment } from "react";
import loaderGif from "../../assets/loader.gif";

const withLoader = props => {
	if (!props.loading) {
		return <Fragment>{props.children}</Fragment>;
	} else {
		return (
			<div className={props.classes ? props.classes : "page-loader"}>
				<img src={loaderGif} className="loader-img" />
			</div>
		);
	}
};

export default withLoader;
